// ImageViewer.jsx
import React, { useEffect, useState } from 'react';
import { useWishlist } from '../hooks/useWishlist';
import constants from '../config/consts';
import '../styles/ImageViewer.css';

import like from '../icons/like.svg';
import likeOrange from '../icons/like_orange.svg';
import nextIcon from '../icons/next.svg';
import previousIcon from '../icons/previous.svg';
import { useLocation } from 'react-router-dom';

const ImageViewer = ({ product, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [touchStartX, setTouchStartX] = useState(null);
  const [touchEndX, setTouchEndX] = useState(null);
  const { isLiked, toggleLike } = useWishlist(product);
  const location = useLocation();

  useEffect(() => {
    if (product) {
      setCurrentImageIndex(0);
      setTouchStartX(null);
      setTouchEndX(null);
      requestAnimationFrame(() => setIsVisible(true));
    }
  }, [product]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  const handleTouchStart = (e) => {
    setTouchStartX(e.targetTouches[0].clientX);
    setTouchEndX(null);
  };

  const handleTouchMove = (e) => {
    setTouchEndX(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStartX === null || touchEndX === null) return;
    const distance = touchStartX - touchEndX;
    if (Math.abs(distance) > 50) {
      if (distance > 0) {
        handleNextImage();
      } else {
        handlePrevImage();
      }
    }
    setTouchStartX(null);
    setTouchEndX(null);
  };

  if (!product) return null;

  const images = product.images?.split(',').map(img => img.trim()) || [product.preViewImg];
  const imageUrl = images[currentImageIndex];

  const handlePrevImage = () => {
    setCurrentImageIndex(prev => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNextImage = () => {
    setCurrentImageIndex(prev => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <div
      className={`imageViewerOverlay ${isVisible ? 'visible' : ''}`}
      onClick={handleClose}
    >
      <div
        className={`imageViewerContent ${isVisible ? 'visible' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className={`closeViewer ${images.length > 1 ? 'mbRightViewer': ''}`} onClick={handleClose}>×</button>
        <div className="imageViewerContainer">
          {images.length > 1 && (
            <button className="sliderButton imagePrevButton" onClick={handlePrevImage}>
              <img src={previousIcon} alt="Назад" />
            </button>
          )}
          <div
            className="imageViewerWrapper"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            <img
              src={`${constants.serverUrl}${imageUrl}`}
              alt={product.title}
              className="fullImage"
            />
            {images.length > 1 && (
              <img src={previousIcon} alt="Назад" className="edgeArrow edgeArrowLeft" />
            )}
            {images.length > 1 && (
              <img src={nextIcon} alt="Вперёд" className="edgeArrow edgeArrowRight" />
            )}
          </div>
          {images.length > 1 && (
            <button className="sliderButton imageNextButton" onClick={handleNextImage}>
              <img src={nextIcon} alt="Вперёд" />
            </button>
          )}
        </div>
        {images.length > 1 && (
          <div className="imageIndicators">
            {images.map((_, index) => (
              <button
                key={index}
                className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
                onClick={() => setCurrentImageIndex(index)}
              />
            ))}
          </div>
        )}
        {location.pathname != '/archive' && <div className="imageData">
          <div className="imageZagl"></div>
          <div className="imageText">
            <p className="imageTitle">{product.title}</p>
            {product?.category === 'Doodle Toys' && product.hight ? <p className="imageTitle">{product.hight} см</p> : null}
            {product.price && <p className="imageTitle">{product.price} р.</p>}
          </div>
           <div className={`imageLike ${images.length > 1 ? 'mbRightViewer': ''}`} onClick={toggleLike}>
            <img
              src={isLiked ? likeOrange : like}
              alt={isLiked ? 'В вишлисте' : 'В вишлист'}
              className={`imageLikeIcon ${images.length > 1 ? 'imgScaleViewerMany': ''}`}
            />
            <p className="imageLikeTip">{isLiked ? 'Удалить' : 'Добавить'}</p>
          </div>
        </div>}
        {location.pathname == '/archive' && <p className="imageTitle">{product.title}</p>}
      </div>
    </div>
  );
};

export default ImageViewer;